import { render, staticRenderFns } from "./drawer.vue?vue&type=template&id=4bff4d80&scoped=true&"
import script from "./drawer.vue?vue&type=script&lang=ts&"
export * from "./drawer.vue?vue&type=script&lang=ts&"
import style0 from "./drawer.vue?vue&type=style&index=0&id=4bff4d80&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bff4d80",
  null
  
)

export default component.exports